module.exports = __webpack_public_path__ + "img/krone.907d7c7e.svg";